import React, { useMemo, useEffect } from 'react';
import classNames from 'classnames';

import useImage from '../hooks/useImage';
import useError from '../hooks/useError';
import errorCofig from '../statics/error';

type ErrorPageProps = {
  mobile?: boolean;
};

/**
 * @description Error 페이지
 * @param {boolean} mobile 모발일 브라우저인지 여부
 */
function ErrorPage({ mobile = false }: ErrorPageProps) {
  // Error Redux 사용
  const { error } = useError();
  // Image Redux 사용
  const { image, check, onErrorServer, onErrorClient } = useImage();

  // 에러 타입에 맞게 Title과 Content 설정
  const { title, content } = useMemo(() => {
    // Note: 1: 서버 오류
    // Note: 2: 클라이언트 오류
    // Note: 3: Rate Limit 오류
    if (error.type === 0) throw new Error('Error type cannot be 0');
    return errorCofig[error.type];
  }, [error.type]);

  // 에러 타입에 맞게 Error Icon 설정
  const iconComp = useMemo(() => {
    const src = error.type === 2 ? image.error_client : image.error_server;
    return <img src={src} alt="Error icon" />;
  }, [error.type, image.error_client, image.error_server]);

  // mobile인지에 따라 Class를 추가하여 Style 변경
  const containerClass = useMemo(
    () => classNames('error-page container', { mobile }),
    [mobile],
  );

  // 고해상도 이미지 랜더링
  useEffect(() => {
    if (error.type === 2 && !check(image.error_client)) onErrorClient();
    else if (!check(image.error_server)) onErrorServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error.type]);

  return (
    <div className={containerClass}>
      <div className="wrapper">
        <div className="error-service-title">
          <p className="text-title">
            <strong className="text-title-large">{error.title}</strong>의
          </p>
          <p className="text-title">인증 요청이 있습니다.</p>
        </div>
        <div className="error-content">
          {iconComp}
          <div className="text-title-small bold">{title}</div>
          <div className="text-body">{content}</div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
